document.addEventListener('DOMContentLoaded', () => {

    const displaySections = document.querySelectorAll('.wp-block-wm-cardioline-display-section');

    for ( var i = 0; i < displaySections.length; i++ ) {

        const framesSplide = new Splide( displaySections[i].querySelector('.splide.-display-section-frames') );
        const buttonsSplide = new Splide( displaySections[i].querySelector('.splide.-display-section-buttons') );
        
        framesSplide.sync( buttonsSplide );
        framesSplide.mount();
        buttonsSplide.mount();

/*         const firstSlide = framesSplide.getAt(0); */

        if ( window.innerWidth < 768 ) {
            framesSplide.remove(0);
        }

/*         window.addEventListener('resize', () => {
            if ( window.innerWidth < 768 ) {
                framesSplide.remove(0);
            }
        }); */

        const buttons = displaySections[i].querySelectorAll('[data-frame-target]');


        buttons.forEach(button => {
            button.addEventListener('mouseover', () => {
                const target = button.getAttribute('data-frame-target');
                button.classList.add('-active');
                framesSplide.go(parseInt(target));
            });
            button.addEventListener('mouseout', () => {
                button.classList.remove('-active');
                framesSplide.go(0);
            });
        });

    }
});